import ga from "./analytics";
import { formatPhone, sortByCustomDisplayOrder } from "./util";
import PropTypes from "prop-types";
import React from "react";

const TeamPhone = ({ classes, prefix, entity, separator }) => {
  return entity.teamMembers && entity.teamMembers.length === 2
    ? sortByCustomDisplayOrder(
        entity.teamMembers,
        entity.siteOptions.teamMemberOptions
      ).map((details) => {
        return (
          <span>
            <span className={classes}>
              {prefix ? <span className="prefix">{prefix}: </span> : null}
              <a
                href={"tel:+1" + details.primaryPhone}
                onClick={() =>
                  ga.event("Agent-Interaction", "Phone", details.primaryPhone)
                }
              >
                {formatPhone(details.primaryPhone)}
              </a>
            </span>
            {separator ? <span className="slash-separator">/</span> : ""}
          </span>
        );
      })
    : null;
};

TeamPhone.propTypes = {
  classes: PropTypes.string,
  entity: PropTypes.object,
  prefix: PropTypes.string,
  separator: PropTypes.bool,
};

export default TeamPhone;



// WEBPACK FOOTER //
// ./src/components/shared/team-phone.js